import {onFind} from "@elements/init-modules-in-scope";
import {removeClass, addClass, on, findAllIn, findIn, hasClass} from '@elements/dom-utils';

const selectors = {
    base: '.js-edit-data',
    data: '.js-edit-data__data',
    form: '.js-edit-data__form',
    btnChange: '.js-edit-data__btn',
    btnSave: '.js-edit-data__btn-save',
    items: '.js-edit-data__item',
    inputs: '.js-edit-data__input',
    deletedFiles: '.js-edit-data__deleted-files',
    newFiles: '.js-edit-data__new-files'
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        console.log("edit data fount....")
        let btn = findIn(selectors.btnChange, baseElement);
        let save = findIn(selectors.btnSave, baseElement);
        let items = findAllIn(selectors.items, baseElement);
        let data = findIn(selectors.data, baseElement);
        let form = findIn(selectors.form, baseElement);
        let deleteFiles = findIn(selectors.deletedFiles, baseElement);
        let newFiles = findIn(selectors.newFiles, baseElement);

        on("click", function(){
            if (hasClass('inputs-hidden', btn)){
                removeClass('inputs-hidden', btn);
                form.setAttribute("hidden", true);
                data.removeAttribute("hidden");
            }else{
                addClass('inputs-hidden', btn);
                form.removeAttribute("hidden");
                data.setAttribute("hidden", true);

                if (btn.getAttribute("data-files")){
                    let files = [];
                    let filesContainer = findIn(".js-edit-data__form-files", baseElement);
                    filesContainer.innerHTML = "";
                    let deletedFiles = []

                    items.forEach((item, index) => {
                        let btn = '<li class="list-inline-item delete-file__item"><button class="btn delete-file__btn btn-icon-text btn-icon-text--right js-edit-data__form-files-delete" type="button" data-file-id="' + item.innerHTML + '">' + item.innerHTML + '<span class="icon icon-bin icon-primary"></span></button></li>';
                        filesContainer.insertAdjacentHTML("beforeend", btn);
                        files.push( item.innerHTML)
                    })

                    let deleteBtns = findAllIn('.js-edit-data__form-files-delete', baseElement);

                    //set hidden input with files to delete
                    deleteBtns.forEach((btn) => {
                        on("click", function(){
                            files.forEach((file) => {
                                if (file === btn.getAttribute("data-file-id")){
                                    files.splice(files.indexOf(file), 1);
                                    deletedFiles.push(file);

                                    deleteFiles.value = deletedFiles.toString();
                                    newFiles.value = files.toString();

                                    btn.setAttribute("hidden", true);
                                }
                            })
                        }, btn)

                    })
                }
            }
        }, btn)

        on("click", function(){
            form.setAttribute("hidden", true);
            data.removeAttribute("hidden");
        }, save)
    });
}
